// Mirrors the DB constraint profiles_username_format — keep the two in sync.
const USERNAME_RE = /^[A-Za-z0-9_]{3,20}$/;

export function validateUsername(name: string): string | null {
  if (name.length < 3 || name.length > 20) return 'Use 3–20 characters';
  if (!USERNAME_RE.test(name)) return 'Letters, digits and _ only';
  return null;
}
